import React from 'react';
import { ToastState } from '../utils/useAdminPage';

interface ToastProps {
  toast: ToastState | null;
}

const Toast: React.FC<ToastProps> = ({ toast }) => {
  if (!toast) return null;

  return (
    <div style={{
      position: 'fixed', top: 24, right: 24, zIndex: 9999,
      padding: '14px 20px', borderRadius: 12,
      background: toast.type === 'success' ? '#f0fdf4' : '#fef2f2',
      border: `1px solid ${toast.type === 'success' ? '#bbf7d0' : '#fecaca'}`,
      color: toast.type === 'success' ? '#166534' : '#b91c1c',
      fontSize: 14, fontWeight: 600,
      boxShadow: '0 8px 24px rgba(0,0,0,0.08)', maxWidth: 360,
      animation: 'toastSlideIn .25s ease',
    }}>
      {toast.msg}
    </div>
  );
};

export default Toast;
